import {
  GET_PUBS,
  GET_PUB,
  ADD_PUB,
  UPDATE_PUB,
  PUBS_LOADING,
  PUBS_ERROR
} from '../actions/types';

const initialState = {
  publications: [],
  currentPublication: null,
  loading: false,
  error: null
};

const publicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case PUBS_LOADING:
      return {
        ...state,
        loading: true,
        error: null
      };
    
    case GET_PUBS:
      return {
        ...state,
        publications: action.payload,
        loading: false,
        error: null
      };
    
    case GET_PUB:
      return {
        ...state,
        currentPublication: action.payload,
        loading: false,
        error: null
      };
    
    case ADD_PUB:
      return {
        ...state,
        publications: [action.payload.publication, ...state.publications],
        loading: false,
        error: null
      };
    
    case UPDATE_PUB:
      return {
        ...state,
        publications: state.publications.map(publication => 
          publication._id === action.payload._id ? action.payload : publication
        ),
        currentPublication: state.currentPublication && state.currentPublication._id === action.payload._id 
          ? action.payload 
          : state.currentPublication,
        loading: false,
        error: null
      };
    
    case PUBS_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    
    default:
      return state;
  }
};

export default publicationReducer;
